import React from "react";

function ConceptKundali({ kundaliUrl }: any) {
  console.log("kundaliUrl", kundaliUrl);
  return (
    <div
      className="mt-3"
      style={{ backgroundColor: "#EEF2FE", borderRadius: "16px" }}
    >
      <iframe
        src={kundaliUrl}
        width="100%"
        height="600px"
        style={{ border: "none", borderRadius: "16px" }}
        title="Concept Kundali"
      ></iframe>
    </div>
  );
}

export default ConceptKundali;
